import styled from "styled-components";
import { breakpoints } from "theme/themes";

const StepQuestionWrap = styled.div`
  position: relative;

  @media ${breakpoints.large} {
    display: flex;
    align-items: flex-start;
  }

  .background-image {
    width: 85%;
    display: flex;
    overflow: hidden;
    pointer-events: none;

    @media ${breakpoints.large} {
      width: 45%;
      max-width: 1200px;
      
    }
   > svg {
      width: 100%;
      height: 100%;
    }
  }

  .content {
    width: 100%;
    position: relative;
    z-index: 1;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;

    @media ${breakpoints.medium} {
      padding-left: 2rem;
      padding-right: 2rem;
    }

    @media ${breakpoints.large} {
      width: 55%;
      margin-left: auto;
      padding-top: 100px;
      padding-bottom: 80px;
    }

    @media ${breakpoints.xl4} {
      padding-right: 150px;
      padding-top: 150px;
      padding-bottom: 120px;
    }
  }

  .buttons {
    display: flex;
    flex-wrap: wrap ;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    margin-bottom: 2rem;

   
    @media ${breakpoints.xl2} {
      margin-top: 3rem;
    }

    .button {
      margin-bottom: 1rem
    }
  }
`;

export default StepQuestionWrap;
